const initialState = {
  search_type: 'RoundTrip',
};

const flightSearchType = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_FLIGHTS_TYPE':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default flightSearchType;
